import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api'

const StudyCircleList = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [studyCircles, setStudyCircles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [newCircle, setNewCircle] = useState({
        name: '',
        description: ''
    });

    useEffect(() => {
        fetchStudyCircles();
    }, []);

    const fetchStudyCircles = async () => {
        try {
            const response = await api.get('/api/study-circles');
            setStudyCircles(response.data);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to fetch study circles');
            console.error('Error fetching study circles:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateCircle = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/api/study-circles', newCircle);
            setStudyCircles([...studyCircles, response.data]);
            setShowCreateModal(false);
            setNewCircle({ name: '', description: '' });
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to create study circle');
            console.error('Error creating study circle:', err);
        }
    };

    const handleDeleteCircle = async (circleId) => {
        if (!window.confirm('Are you sure you want to delete this study circle?')) {
            return;
        }

        try {
            await api.delete(`/api/study-circles/${circleId}`);
            setStudyCircles(studyCircles.filter(circle => circle.id !== circleId));
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to delete study circle');
            console.error('Error deleting study circle:', err);
        }
    };

    if (loading) {
        return <div className="text-center mt-5">Loading...</div>;
    }

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Study Circles</h2>
                {user.role === 'admin' && (
                    <button
                        className="btn btn-primary"
                        onClick={() => setShowCreateModal(true)}
                    >
                        Create Study Circle
                    </button>
                )}
            </div>

            {error && (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            )}

            <div className="row">
                {studyCircles.map(circle => (
                    <div key={circle.id} className="col-md-4 mb-4">
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">{circle.name}</h5>
                                <div
                                    className="card-text"
                                    dangerouslySetInnerHTML={{ __html: circle.description }}
                                />
                                <div className="d-flex justify-content-between align-items-center">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => navigate(`/study-circles/${circle.id}`)}
                                    >
                                        Manage
                                    </button>
                                    {user.role === 'admin' && (
                                        <button
                                            className="btn btn-danger"
                                            onClick={() => handleDeleteCircle(circle.id)}
                                        >
                                            Delete
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Create Study Circle Modal */}
            {showCreateModal && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Create Study Circle</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowCreateModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleCreateCircle}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            value={newCircle.name}
                                            onChange={(e) =>
                                                setNewCircle({ ...newCircle, name: e.target.value })
                                            }
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">
                                            Description
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            value={newCircle.description}
                                            onChange={(e) =>
                                                setNewCircle({ ...newCircle, description: e.target.value })
                                            }
                                            required
                                        />
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <button
                                            type="button"
                                            className="btn btn-secondary me-2"
                                            onClick={() => setShowCreateModal(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary">
                                            Create
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StudyCircleList; 